/* global System */
// register component(s) with react habitat

export default {
  MagazinSlider: () =>
    System.import(/* webpackChunkName: "MagazinSlider" */ './component'),
}
